import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    breadCrumb: {
      fontSize: FontSizes.s16,
      padding: [Spacings.s10, Spacings.s8],
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      '@media screen and (max-width: 768px)': {
        fontSize: FontSizes.s14,
        padding: [Spacings.s10, Spacings.s4],
        lineHeight: LineHeights.l20,
      },
      '&[class*=active]': {
        cursor: 'default',
      },
    },
    breadcrumbWrapper: {
      display: 'flex',
      gap: Spacings.s2,
      '&&': {
        '& svg': {
          width: 24,
          height: 24,
          right: Spacings.s4,
          '@media screen and (max-width: 768px)': {
            width: 20,
            height: 20,
          },
        },
      },
    },
  },
  {
    name: 'bread-crumbs-style',
  },
);

export default useStyles;
